<template lang="html">
  <div class="monitor">
    <v-header :name="name"></v-header>
    <div class="container">
      <div class="swiper-container">
        <swiper :options="swiperOption" class="swiper-wrap"  ref="mySwiper" v-if="banner.length!=0">
          <swiper-slide v-for="(item,index) in banner" :key="index">
            <img :src="item" alt=""/>
          </swiper-slide>
          <!-- 常见的小圆点 -->
          <!-- <div class="swiper-pagination"  v-for="(item,index) in banner" :key="index" slot="pagination" ></div> -->
        </swiper>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>

      <div class="produce-flow">
        <!-- <img class="left-img" src="../../../static/img/product/8.png" alt="">
        <img class="right-img" src="../../../static/img/product/7.png" alt=""> -->
        <p class="tit">产品生产流程：</p>
        <div class="list">
          <img src="../../../static/img/product/flow-chart.png" alt="">
          <!-- <div class="item-container" v-for="(item,index) in steps1" :key="index">
            <div class="list-item">
              <div class="top">
                <img :src="item.src" alt="">
              </div>
              <div class="bottom">{{index+1}}.{{item.name}}</div>
            </div>
            <div class="list-line" v-show="index!=4">
              <img src="../../../static/img/product/5.png" alt="">
            </div>
          </div>

          <div class="item-container" v-for="(item,index) in steps2" :key="index">
            <div class="list-item">
              <div class="top">
                <img :src="item.src" alt="">
              </div>
              <div class="bottom">{{10-index}}.{{item.name}}</div>
            </div>
            <div class="list-line" v-show="index!=4">
              <img src="../../../static/img/product/6.png" alt="">
            </div>
          </div>

          <div class="item-container" v-for="(item,index) in steps3" :key="index">
            <div class="list-item">
              <div class="top">
                <img :src="item.src" alt="">
              </div>
              <div class="bottom">{{index+11}}.{{item.name}}</div>
            </div>
            <div class="list-line" v-show="index!=4">
              <img src="../../../static/img/product/5.png" alt="">
            </div>
          </div> -->

        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import header from 'components/common/header'
import '../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import certify01 from '../../../static/img/product/certify01.png'
import certify02 from '../../../static/img/product/certify02.png'
import certify03 from '../../../static/img/product/certify03.png'

import pic1 from '../../../static/img/product/pic1.png'
import pic2 from '../../../static/img/product/pic2.png'
import pic3 from '../../../static/img/product/pic3.png'
import pic4 from '../../../static/img/product/pic4.png'
import pic5 from '../../../static/img/product/pic5.png'

import pic6 from '../../../static/img/product/pic6.png'
import pic7 from '../../../static/img/product/pic7.png'
import pic8 from '../../../static/img/product/pic8.png'
import pic9 from '../../../static/img/product/pic9.png'
import pic10 from '../../../static/img/product/pic10.png'

import pic11 from '../../../static/img/product/pic11.png'
import pic13 from '../../../static/img/product/pic13.png'
import pic14 from '../../../static/img/product/pic14.png'
import pic15 from '../../../static/img/product/pic15.png'

export default {
  data() {
    const that = this;
    return {
      name: '田阳县农业大脑——特色产品展示',
      banner: [certify01, certify02, certify03],
      steps1: [
        { name: '采摘', src: pic1 },
        { name: '鲜叶农残快速检测', src: pic2 },
        { name: '收鲜', src: pic3 },
        { name: '摊青', src: pic4 },
        { name: '杀青', src: pic5 }],
      steps2: [
        { name: '干燥', src: pic10 },
        { name: '渥堆', src: pic9 },
        { name: '分筛', src: pic8 },
        { name: '晾晒', src: pic7 },
        { name: '揉捻', src: pic6 }],
      steps3: [
        { name: '送检', src: pic11 },
        { name: '压制', src: pic11 },
        { name: '包装', src: pic13 },
        { name: '装箱', src: pic14 },
        { name: '入库', src: pic15 }],
      swiperOption: {
        watchSlidesProgress: true,
        // 滑动方向
        direction: "horizontal",
        // 循环
        loop: true,
        slidesPerView: 3,
        centeredSlides: true,
        // 自动播放
        autoplay: {
          delay: 3000,
          // stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // 滑动速度
        speed: 800,
        // 小手掌抓取滑动
        // grabCursor: true,
        on: {
        }
      }
    }
  },
  mounted() {
  },
  methods: {
  },
  components: {
    'v-header': header,
    swiper,
    swiperSlide
  }
}

</script>

<style lang="stylus" scoped>
.monitor {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: url('../../../static/img/common/bg.png');
  background-size: 100% 100%;
}

.container {
  height: 100%;
  width: 100%;
  box-sizing:border-box;
  padding: 20px 0;
  box-sizing:border-box;
  
  .swiper-container{
    width: 100%;
    height: 360px;
    overflow: hidden;
    margin: 0 auto;
    padding: 0 25px;
    box-sizing: border-box;
    .swiper-slide{
      width:636px;
      height: 360px;
      &.swiper-slide-active{
        img{
          margin-top 0
          width:606px;
          height: 360px;
        }
      }
      img{
        display block
        margin 0 auto
        margin-top 3.5%
        width 90.625%
        height 90.625%
        vertical-align middle
        -webkit-transition all 1s ease 0s
        -moz-transition all 1s ease 0s
        -ms-transition all 1s ease 0s
        -o-transition all 1s ease 0s
        transition all 1s ease 0s
      }
    }
    
  }
  .swiper-button-next, .swiper-button-prev {
    width: 38px;
    height: 78px;
    top: 200px;
  }

  .swiper-button-prev {
    background: url('../../../static/img/product/1.png');
    background-size: 100% 100%;
    left:15px;
  }

  .swiper-button-next {
    background: url('../../../static/img/product/2.png');
    background-size: 100% 100%;
    right: 15px;
  }

  .produce-flow {
    position: relative;
    width: 1800px;
    text-align: center;
    padding-left: 100px;

    .left-img {
      position: absolute;
      left: 166px;
      top: 268px;
    }

    .right-img {
      position: absolute;
      top: 100px;
      right: 148px;
    }

    .tit {
      font-size: 32px;
      color: rgba(255, 255, 255, 1);
      margin-left: 100px;
      margin-top: 46px;
      text-align: left;
    }

    .list {
      display: flex;
      flex-wrap: wrap;
      padding: 30px 118px;
      box-sizing: border-box;

      .item-container {
        display: flex;
        margin-bottom: 20px;
      }

      .list-item {
        color: #fff;
        font-size: 20px;

        .top {
          width: 204px;
          height: 100px;
          padding-top: 12px;
          padding-left: 18px;
          box-sizing: border-box;
          background: url('../../../static/img/product/4.png') no-repeat;
        }

        .bottom {
          margin-top: 15px;
          text-align: center;
        }
      }

      .list-line {
        width: 70px;
        margin: 0 10px;
        height: 2px;
        background: rgba(18, 91, 224, 1);
        margin-top: 60px;
        position: relative;

        img {
          position: absolute;
          left: 30px;
          top: -30px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?57e42127